var _rect, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 288,
    viewBox: "0 0 289 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.948,
    y: 117,
    width: 54,
    height: 54,
    rx: 7,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.948 150H146.948V148H142.948V150ZM135.948 138V140H153.948V138H135.948ZM138.948 145H150.948V143H138.948V145Z",
    fill: "black",
    fillOpacity: 0.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 102.223,
    y: 93.0834,
    width: 94,
    height: 94,
    rx: 7,
    transform: "rotate(5 102.223 93.0834)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 87.2677,
    y: 62.1038,
    width: 142,
    height: 142,
    rx: 7,
    transform: "rotate(10 87.2677 62.1038)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 80.7091,
    y: 32.6564,
    width: 182,
    height: 182,
    rx: 7,
    transform: "rotate(15 80.7091 32.6564)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 78.1582,
    y: 1.28171,
    width: 222,
    height: 222,
    rx: 7,
    transform: "rotate(20 78.1582 1.28171)",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilterIcon);
export default __webpack_public_path__ + "static/media/empty-filter-icon.de4c191706622d7a2ee71e86446c5f8c.svg";
export { ForwardRef as ReactComponent };